class Vault {
	constructor() {
		this.subscriptions = {};
		this.inMemoryStorage = {};
		this.storage = window.localStorage;
		this.hasLocalStorage = this.isSupported();

		window.addEventListener("storage", this.storageListener, false);
	}

	get length() {
		if (this.hasLocalStorage) {
			return this.storage.length;
		}

		return Object.keys(this.inMemoryStorage).length;
	}

	storageListener = (event) => {
		const keyName = event.key;

		try {
			if (this.subscriptions[keyName]) {
				this.subscriptions[keyName].forEach((subscription) => {
					subscription(this.get(keyName), this);
				});
			}
		} catch (ermahgerd) {
			// swallow error
		}
	};

	subscribe = (name, callback) => {
		if (!this.subscriptions[name]) {
			this.subscriptions[name] = [];
		}

		this.subscriptions[name].push(callback);
	};

	unsubscribe = (name, callback) => {
		if (this.subscriptions[name]) {
			this.subscriptions[name] = this.subscriptions[name].filter((d) => d !== callback);
		}
	};

	isSupported = () => {
		try {
			const testKey = "__random_key__";
			this.storage.setItem(testKey, testKey);
			this.storage.removeItem(testKey);
			return true;
		} catch (ermahgerd) {
			return false;
		}
	};

	set = (name, value) => {
		if (this.hasLocalStorage) {
			this.storage.setItem(name, value);
		} else {
			this.inMemoryStorage[name] = value;
		}
	};

	get = (name) => {
		if (this.hasLocalStorage) {
			return this.storage.getItem(name);
		}

		return this.inMemoryStorage[name];
	};

	delete = (name) => {
		if (this.hasLocalStorage) {
			this.storage.removeItem(name);
		} else {
			delete this.inMemoryStorage[name];
		}
	};

	clear = () => {
		if (this.hasLocalStorage) {
			this.storage.clear();
		} else {
			this.inMemoryStorage = {};
		}
	};

	key = (index) => {
		if (this.hasLocalStorage) {
			return this.storage.key(index);
		}

		return Object.keys(this.inMemoryStorage)[index] || null;
	};
}

export default Vault;
